import { useCallback, useEffect, useState } from 'react'

import api from 'common/api'

export type CareerOption = {
  SOC: string
  Title: string
  name: string
  tokens: string[]
  value: string
}
export const onCareerSearch = (val: string) => {
  return api.get<CareerOption[]>(`/api/careers?query=${val}`)
}

export type RelatedCareerOption = {
  MedianIncome?: number
  Outlook?: string
  Title: string
  EducationLevel?: string
  SOC: string
  Industry?: string
}

export const useRelatedCareerSearch = (selectedCareers: CareerOption[]) => {
  const [relatedCareers, setRelatedCareers] = useState<RelatedCareerOption[]>([])
  const careerId = selectedCareers[selectedCareers.length - 1]?.value

  const fetch = useCallback(() => {
    if (!careerId) return { relatedCareers: [] }
    return api
      .get<RelatedCareerOption[]>(`/api/careers/${careerId}/related`)
      .then((response) => {
        setRelatedCareers(response)
      })
      .catch((e) => {
        console.log(e)
      })
  }, [careerId])

  useEffect(() => {
    fetch()
  }, [fetch])

  const filteredRelated = relatedCareers.filter((related) => {
    return !selectedCareers.find((selected) => {
      return selected.Title === related.Title
    })
  })

  return { relatedCareers: filteredRelated.slice(0, 5) }
}
